import { FC } from "react"
import { StatCard } from "@/components/StatCard"
import { ActiveDeviceModal } from "./ActiveDeviceModal"
import { LeakInfoModal } from "@/components/LeakInfoModal"
import { Gauge, Cpu, Users, AlertTriangle } from "lucide-react"

interface CouncilStatsProps {
  customers?: number
  activeLeaks?: number
  totalLeaksDetected?: number
  activeDevices?: number
  totalDevices?: number
}

const safeNum = (v: unknown, fallback = 0): number => (typeof v === "number" ? v : fallback)

const CouncilStats: FC<CouncilStatsProps> = ({
  activeLeaks = 0,
  totalLeaksDetected = 0,
  customers = 0,
  activeDevices,
  totalDevices,
}) => {
  const safeCustomers = safeNum(customers)
  const safeLeaks = safeNum(activeLeaks)
  const safeTotalLeaksDetected = safeNum(totalLeaksDetected)

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
      <StatCard
        title="Total Devices"
        value={safeNum(totalDevices)}
        icon={Cpu}
        subtitle="Smart meters & loggers"
      />
      <StatCard
        title="Active Devices"
        value={safeNum(activeDevices)}
        icon={Gauge}
        subtitle="Currently online"
        action={<ActiveDeviceModal />}
      />
      <StatCard
        title="Total Customers"
        value={safeCustomers}
        icon={Users}
        subtitle="Registered users"
      />
      <StatCard
        title="Active Leaks"
        value={safeLeaks}
        icon={AlertTriangle}
        className="border-destructive/20"
        subtitle="Requires attention"
        action={<LeakInfoModal />}
      />
      <StatCard
        title="Total Leaks Detected"
        value={safeTotalLeaksDetected}
        icon={AlertTriangle}
        subtitle="Leaks Detected Since Admin Portal Start"
      />
    </div>
  )
}

export default CouncilStats
